export const defaultStrings = {
  'country.name.canada': 'Canada',
  'country.name.ireland': 'Ireland',
  'country.name.united_kingdom': 'United Kingdom',
  'country.name.united_states': 'United States',
  'country.name.australia': 'Australia',
  'country.name.india': 'India',
  'country.name.new_zealand': 'New Zealand'
}

export type DefaultStrings = typeof defaultStrings
